const HUB_ONLY_DESCRIPTION = 'Desligar afeta so push. O aviso continua no hub.';

export const NOTIFICATION_TYPES = [
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_CREATED',
    value: 'conversation_creation',
    description:
      'Toda vez que QUALQUER conversa nova entra na conta. Recomendado apenas pra administradores: agentes recebem ruido demais.',
    adminOnly: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_ASSIGNED',
    value: 'conversation_assignment',
    description:
      'Quando uma conversa e atribuida especificamente a voce: voce e o agente responsavel.',
    adminOnly: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_MENTION',
    value: 'conversation_mention',
    description:
      'Quando alguem menciona voce com @ em uma nota interna de conversa.',
    adminOnly: false,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.ASSIGNED_CONVERSATION_NEW_MESSAGE',
    value: 'assigned_conversation_new_message',
    description: 'Cada nova mensagem em conversa que esta atribuida a voce.',
    adminOnly: false,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PARTICIPATING_CONVERSATION_NEW_MESSAGE',
    value: 'participating_conversation_new_message',
    description:
      'Cada nova mensagem em conversa que voce ja participou (mesmo nao atribuida).',
    adminOnly: false,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_FIRST_RESPONSE',
    value: 'sla_missed_first_response',
    description:
      'Conversa atribuida a voce passou do prazo de SLA para primeira resposta.',
    adminOnly: false,
    requiresSla: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_NEXT_RESPONSE',
    value: 'sla_missed_next_response',
    description:
      'Conversa atribuida a voce passou do prazo de SLA para proxima resposta.',
    adminOnly: false,
    requiresSla: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_RESOLUTION',
    value: 'sla_missed_resolution',
    description:
      'Conversa atribuida a voce passou do prazo de SLA para resolucao.',
    adminOnly: false,
    requiresSla: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CAPTAIN_HANDOFF',
    value: 'captain_handoff',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CAPTAIN_FOLLOW_UP_DUE',
    value: 'captain_follow_up_due',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CAPTAIN_RUNNER_FAILURE',
    value: 'captain_runner_failure',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CAPTAIN_PAUSED',
    value: 'captain_paused',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CAPTAIN_SCHEDULING_FAILED',
    value: 'captain_scheduling_failed',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CAPTAIN_PENDING_AUTO_RESOLVED',
    value: 'captain_pending_auto_resolved',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.KANBAN_ITEM_ASSIGNMENT',
    value: 'kanban_item_assignment',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.KANBAN_ITEM_UNASSIGNMENT',
    value: 'kanban_item_unassignment',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.KANBAN_CHECKLIST_ITEM_ASSIGNMENT',
    value: 'kanban_checklist_item_assignment',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.KANBAN_CHECKLIST_ITEM_UNASSIGNMENT',
    value: 'kanban_checklist_item_unassignment',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.TASK_ASSIGNED',
    value: 'task_assigned',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.TASK_STATUS_CHANGED',
    value: 'task_status_changed',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.TASK_DEPENDENCY_RESOLVED',
    value: 'task_dependency_resolved',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.TASK_MENTION',
    value: 'task_mention',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.VOIP_HOT_LEAD',
    value: 'voip_hot_lead',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
    requiresVoip: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.VOIP_SALE_CLOSED',
    value: 'voip_sale_closed',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
    requiresVoip: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.VOIP_NEGATIVE_SENTIMENT',
    value: 'voip_negative_sentiment',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
    requiresVoip: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.VOIP_CRITICAL_KEYWORD',
    value: 'voip_critical_keyword',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
    requiresVoip: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.VOIP_MISSED_HOT_CALL',
    value: 'voip_missed_hot_call',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
    requiresVoip: true,
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.VOIP_APPOINTMENT_REMINDER',
    value: 'voip_appointment_reminder',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
    requiresVoip: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.VOIP_SLA_VIOLATION',
    value: 'voip_sla_violation',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
    requiresVoip: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.LEAD_CAPTURE_FORM',
    value: 'lead_capture_form',
    description: HUB_ONLY_DESCRIPTION,
    adminOnly: false,
    emailSupported: false,
  },
];

// Tipos VOIP ficam em NOTIFICATION_TYPES com requiresVoip. Nao duplicar aqui.
export const VOIP_NOTIFICATION_TYPES = NOTIFICATION_TYPES.filter(
  item => item.requiresVoip
);

export const EVENT_TYPES = {
  ASSIGNED: 'assigned',
  NOTME: 'notme',
  UNASSIGNED: 'unassigned',
};

export const ALERT_EVENTS = [
  {
    value: EVENT_TYPES.ASSIGNED,
    label: 'assigned',
  },
  {
    value: EVENT_TYPES.UNASSIGNED,
    label: 'unassigned',
  },
  {
    value: EVENT_TYPES.NOTME,
    label: 'notme',
  },
];
